import React from 'react';
import OrderListTable from "../../../components/OrderListTable";
import {ShippingStatus} from "../../../../types/order";
import {ProductType} from "../../../../types/product";

export const ReturnProductsOrderPage = () => {
  return <OrderListTable status={ShippingStatus.RETURN} type={ProductType.GENERAL}/>;
}
